// Recall rejects a bot name longer than this — mirrors Notetaker::MAX_NAME_LENGTH
export const MAX_BOT_NAME_LENGTH = 100

export type NotetakerRecordingLayout = "speaker_view" | "gallery_view_v2"

export enum NotetakerJoinRule {
  OWNER = "owner",
  WITH_EXTERNAL_PARTICIPANTS = "with_external_participants",
}

export const JOIN_RULE_LABELS: Record<NotetakerJoinRule, string> = {
  [NotetakerJoinRule.OWNER]: "When I am the organizer",
  [NotetakerJoinRule.WITH_EXTERNAL_PARTICIPANTS]: "When I'm invited and external participants are present",
}

export enum RetentionMode {
  KEEP_FOREVER = "keep_forever",
  EXPIRE_AFTER_DAYS = "expire_after_days",
  DISCARD_IMMEDIATELY = "discard_immediately",
}

export const RETENTION_MODE_LABELS: Record<RetentionMode, string> = {
  [RetentionMode.KEEP_FOREVER]: "Keep forever",
  [RetentionMode.EXPIRE_AFTER_DAYS]: "Delete after specific time",
  [RetentionMode.DISCARD_IMMEDIATELY]: "Delete after meeting notes are created",
}

export interface RawNotetakerSettings {
  recording_layout: NotetakerRecordingLayout
  id: string
  bot_name?: string
  effective_bot_name: string
  book_id: string
  has_bot_avatar?: boolean
  bot_avatar_url?: string
  bot_avatar_base64?: string
  company_defaults?: {
    bot_name: string | null
    bot_avatar_url?: string
    bot_avatar_base64?: string
  }
}

export interface NotetakerSettings {
  recordingLayout: NotetakerRecordingLayout
  id: string
  botName?: string
  effectiveBotName: string
  bookId: string
  hasBotAvatar?: boolean
  botAvatarUrl?: string
  botAvatarBase64?: string
  companyDefaults?: {
    botName: string | null
    botAvatarUrl?: string
    botAvatarBase64?: string
  }
}

export function processNotetakerSettings(settings: RawNotetakerSettings): NotetakerSettings {
  return {
    recordingLayout: settings.recording_layout,
    id: settings.id,
    botName: settings.bot_name,
    effectiveBotName: settings.effective_bot_name,
    bookId: settings.book_id,
    hasBotAvatar: settings.has_bot_avatar,
    botAvatarUrl: settings.bot_avatar_url,
    botAvatarBase64: settings.bot_avatar_base64,
    companyDefaults: settings.company_defaults
      ? {
          botName: settings.company_defaults.bot_name,
          botAvatarUrl: settings.company_defaults.bot_avatar_url,
          botAvatarBase64: settings.company_defaults.bot_avatar_base64,
        }
      : undefined,
  }
}

export interface RawCompanyNotetakerSettings {
  recording_layout: NotetakerRecordingLayout
  id: string
  bot_name: string | null
  effective_bot_name: string
  has_bot_avatar: boolean
  bot_avatar_url?: string
  bot_avatar_base64?: string
}

export interface CompanyNotetakerSettings {
  recordingLayout: NotetakerRecordingLayout
  id: string
  botName: string | null
  effectiveBotName: string
  hasBotAvatar: boolean
  botAvatarUrl?: string
  botAvatarBase64?: string
}

export function processCompanyNotetakerSettings(settings: RawCompanyNotetakerSettings): CompanyNotetakerSettings {
  return {
    recordingLayout: settings.recording_layout,
    id: settings.id,
    botName: settings.bot_name,
    effectiveBotName: settings.effective_bot_name,
    hasBotAvatar: settings.has_bot_avatar,
    botAvatarUrl: settings.bot_avatar_url,
    botAvatarBase64: settings.bot_avatar_base64,
  }
}
